import React, { useEffect } from 'react';
import SharedButton from '../../components/Shared/SharedButton';
import { useTranslation } from 'react-i18next';
import DeductionTable from './DeductionTable';
import { useNavigate } from 'react-router-dom';
import useFetchData from '../../hooks/useFetchData';

export default function DeductionMain() {
  const { data: deductionData, loading, executeFetch } = useFetchData();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    executeFetch("POST", "deductions/list", { page: 1, per_page: 10 });
  }, [executeFetch]);

  const handlePageChange = (newPage, newRowsPerPage) => {
    executeFetch("POST", "deductions/list", { page: newPage, per_page: newRowsPerPage });
  };

  const handleRefresh = () => {
    executeFetch("POST", "deductions/list", { page: 1, per_page: 10 });
  };

  return (
    <>
      <div>
        <div className='flex justify-end mb-2 '>
          <SharedButton
            label={t('CreateDeduction')}
            icon='pi pi-plus'
            onClick={() => navigate('/manager/deduction/create')}
            className='bg-primary primary-btn'
          />
        </div>
        <DeductionTable
          data={deductionData}
          loading={loading}
          onPageChange={handlePageChange}
          onRefresh={handleRefresh}
        />
      </div>
    </>
  );
}
